import * as R from 'ramda';

import generator from "../../hor/module";
import fetchWithView from "../../utils/fetchWithView";
import {createAction} from "redux-act";

const {
  reducer,
  fetch,
  clearSuccess
} = generator({
  name: 'Requests_All',
  tableId: 219,
  parseItem: R.compose(
    R.evolve({
      custom_вопрос: R.defaultTo(''),
      custom_закрыта: R.defaultTo(false),
      ___modifieddate: R.identity,
    }),
    item => R.pipe(
      R.dissoc('___modifieddate'),
      R.assoc('modifiedDate', item.___modifieddate)
    )(item)
  ),
})

export {
  fetch,
  clearSuccess
}

export {
  getClientAllRequestsSelector,
  getClientAllRequestParamsSelector
} from './selectors'

export const fetchAllClientRequests = fetchWithView(fetch, "_all");

export default reducer;